import { canv } from "@/canv/global";
import { toolBase } from "@/tools/toolBase";

export class ActiveVoteTool extends toolBase {
    TryAction(type: string) {
        const pt = canv.actionManager.getActionPoint();
        const activeVoteInterface = canv.appInterface.activeVote.interface;

        if (type === "mousemove") {
            activeVoteInterface?.handleMouseMove(pt);
            this.updateCursor();
        } else if (type === "mouseup") {
            activeVoteInterface?.handleMouseUp(pt);
        }
    }

    updateCursor() {
        const activeVoteInterface = canv.appInterface.activeVote.interface;

        if (!activeVoteInterface) return;

        this.setCursor(activeVoteInterface.isHover ? "pointer" : "default");
    }

    setCursor(cursor: string) {
        if (cursor === this.cursor) return;

        document.body.style.cursor = cursor;
        this.cursor = cursor;
    }

    cursor = "default";
    name = "activeVoteTool";
}
